import { ref } from '@nuxtjs/composition-api'
import { getCountryCode } from '~/assets/ts/Locale'

export type BudgetRange = {
  status: boolean
  start: number
  end: number
}

type BudgetType = 'low' | 'medium' | 'high'

function getCurrencyFactor(country: string): number {
  switch (country) {
    case 'kr':
      return 1350 // South Korean Won
    case 'dk':
      return 8.5 // Danish Krone
    case 'us':
      return 1.05 // US Dollar
    case 'tw':
      return 35.5 // Taiwan Dollar
    case 'hk':
      return 9.3 // Hong Kong Dollar
    case 'jp':
      return 141 // Japanese Yen
    case 'au':
      return 1.57 // Australian Dollar
    case 'sg':
      return 1.42 // Singapore Dollar
    case 'no':
      return 10.4 // Norwegian Krone
    case 'cz':
      return 25.5 // Czech Koruna
    case 'is':
      return 140 // Icelandic Krona
    default:
      return 1
  }
}

export function useBudgetFilter() {
  const filterBudget = ref<BudgetRange>({
    status: false,
    start: 1001,
    end: 3000,
  })

  const setBudget = (budgetType: BudgetType) => {
    const valid: BudgetType[] = ['low', 'medium', 'high']
    if (!valid.includes(budgetType)) return

    const factor = getCurrencyFactor(getCountryCode())

    let startBudget = 0
    let endBudget = 100000 * factor

    switch (budgetType) {
      case 'low':
        endBudget = 1000 * factor
        break
      case 'medium':
        startBudget = 1001 * factor
        endBudget = 3000 * factor
        break
      case 'high':
        startBudget = 3001 * factor
        break
    }

    filterBudget.value.status = true
    filterBudget.value.start = startBudget
    filterBudget.value.end = endBudget
  }

  // Initialize budget filter from route name if it contains BudgetLow/Medium/High
  const initFromRoute = (routeName?: string | null) => {
    if (!routeName) return
    if (routeName.includes('BudgetLow')) setBudget('low')
    else if (routeName.includes('BudgetMedium')) setBudget('medium')
    else if (routeName.includes('BudgetHigh')) setBudget('high')
  }

  const clearBudget = () => {
    filterBudget.value.status = false
  }

  return { filterBudget, setBudget, initFromRoute, clearBudget }
}
